import React, {useContext} from 'react';
import {Controller} from "react-hook-form";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import withStyles from '@mui/styles/withStyles';
import {isEmpty} from "../../../utils/GenericUtils";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import {languages} from "../../../strings/LanguageDictionary";
import {AppContext} from "../../../App";


export const CustomAutoComplete = ({
	                                   onChange: ignored,
	                                   control,
	                                   label,
	                                   name,
	                                   options,
	                                   multiple,
	                                   rules,
	                                   error,
	                                   freeSolo = false,
	                                   disabled = false,
	                                   placeholder = "",
	                                   variant = "outlined"
                                   }) => {
	const appContext = useContext(AppContext);
	
	return (
		<React.Fragment>
			<Controller
				render={({onChange, ...props}) => (
					<Custom
						multiple={multiple}
						options={options}
						disabled={disabled}
						freeSolo={freeSolo}
						disableClearable={freeSolo}
						renderOption={option => option}
						renderInput={params => {
							params.inputProps.onKeyDown = (event) => {
								switch (event.key) {
									case ",":
									case "Enter":
									case "\n":
									case "\t":
									case "Alt":
									case "Tab":
									case " ":
										if (event.target.value.length > 0 && freeSolo) {
											onChange(event.target.value);
										}
										break;
									default:
										break;
								}
							}
							return (
								<TextField
									{...params}
									disabled={disabled}
									placeholder={placeholder}
									error={!isEmpty(error)}
									helperText={error?.type === "validate" ? languages[appContext.state.lang].OCEAN__GLOBAL_NOT_VALID_FILES : error?.message ? languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_ : ""}
									FormHelperTextProps={{
										style: getHelperStyle().helper
									}}
									label={label}
									variant={variant}
								/>
							)
						}}
						onChange={(e, data) => onChange(data)}
						{...props}
					/>
				)}
				onChange={([, data]) => data}
				defaultValue={multiple ? [] : ""}
				name={name}
				control={control}
				rules={rules}
			/>
		</React.Fragment>
	);
};

const Custom = withStyles((theme) => ({
	tag: {
		backgroundColor: theme.palette.primary.main,
		margin: 4,
		marginTop: 8,
		zIndex: 0,
		"& .MuiChip-label": {
			color: "#fff"
		},
		"& .MuiChip-deleteIcon": {
			color: theme.palette.primary.light
		},
	}
}))(Autocomplete);
